require("./bootstrap");
import App from "./App.vue";
import Default from "./Layouts/AppLayout.vue";
import AuthLayout from "./Layouts/AuthLayout.vue";
import { createApp } from "vue";
import { router } from "./router";
import store from "./store";
import fr from "./locales/fr";
import { createI18n } from "vue-i18n";
import setupInterceptors from "./services/setupInterceptors";
import moment from "moment";
import vClickOutside from "click-outside-vue3"
setupInterceptors(store);

import BootstrapVue3 from "bootstrap-vue-3";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "vue-select/dist/vue-select.css";

import VueCookieAcceptDecline from "vue-cookie-accept-decline";
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";

import vSelect from "vue-select";

import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

const i18n = createI18n({
  locale: 'fr',
  messages: {fr},
  fallbackLocale: "fr",
});

const app = createApp(App);
app.use(vClickOutside);
app.component("LayoutDefault", Default); 
app.component("LayoutAuth", AuthLayout); 
app.component("v-select", vSelect);
app.component("date-picker", Datepicker);
app.component("vue-cookie-accept-decline", VueCookieAcceptDecline);
app.use(store);
app.use(router);
app.use(BootstrapVue3);
app.use(i18n);
app.config.globalProperties.$filters = {
  date(value) {
    return moment(value).locale("fr").format("DD/MM/YYYY");
    }
  }
app.mount("#app");
